import { postJson } from '../config/HttpClient'
import { formatarKz } from '@/utils/moeda'
import { arredondarParaBaixo } from '@/utils/calculo'
import type { ItemCarrinho } from '@/store/carrinho'

export interface CriarFacturaReciboRequest {
  impos_retido: string
  id_cliente: number
  id_contafk: number
  total: string
  total_final: string
  taxa: string
  tipoPagamento: string
  valor_desconto: string
  desconto: string
  num_itens: number
  codigoReserva: string | null
  valorBanco: string
  valorCash: string
  id_categoria: number[]
  id_produto: number[]
  qtd: number[]
  preco: string[]
  subtotal: string[]
  taxa_prod: string[]
  tipo_prod: string[]
  ref_cat: string[]
}

export interface FacturaResultado {
  sucesso: boolean
  idCodificado?: string
  mensagem?: string
}

export interface PayloadFacturaOpcoes {
  itens: ItemCarrinho[]
  idCliente: number
  idConta: number
  tipoPagamento: string
  valorDesconto: number
  percentualDesconto: number
  total: number
  totalFinal: number
  taxa: number
  valorBanco: number
  valorCash: number
  codigoReserva?: string | null
}

class VendaService {
  async criarFacturaRecibo(payload: CriarFacturaReciboRequest): Promise<FacturaResultado> {
    return postJson<FacturaResultado>('/pos/criar-factura-recibo', payload)
  }

  montarPayload(opcoes: PayloadFacturaOpcoes): CriarFacturaReciboRequest {
    return {
      impos_retido: formatarKz(0),
      id_cliente: opcoes.idCliente,
      id_contafk: opcoes.idConta,
      total: formatarKz(opcoes.total),
      total_final: formatarKz(opcoes.totalFinal),
      taxa: formatarKz(opcoes.taxa),
      tipoPagamento: opcoes.tipoPagamento,
      valor_desconto: formatarKz(opcoes.valorDesconto),
      desconto: String(opcoes.percentualDesconto).replace('.', ','),
      num_itens: opcoes.itens.length,
      codigoReserva: opcoes.codigoReserva ?? null,
      valorBanco: formatarKz(opcoes.valorBanco),
      valorCash: formatarKz(opcoes.valorCash),
      id_categoria: opcoes.itens.map(item => item.idCategoria),
      id_produto: opcoes.itens.map(item => item.id),
      qtd: opcoes.itens.map(item => item.qtd),
      preco: opcoes.itens.map(item => formatarKz(item.preco)),
      subtotal: opcoes.itens.map(item => formatarKz(arredondarParaBaixo(item.preco * item.qtd, 2))),
      taxa_prod: opcoes.itens.map(item => formatarKz(item.taxa)),
      tipo_prod: opcoes.itens.map(item => item.tipoArtigo),
      ref_cat: opcoes.itens.map(item => item.referenciaCategoria)
    }
  }
}

export default new VendaService()
